import { Calendar, Tabs } from 'antd';
import DateFilteredReport from './DateFilteredReport';
import StickyBox from 'react-sticky-box';
import {
  TableOutlined
} from '@ant-design/icons';
import InstantReport from './InstantReport';

const items = [
  {
    id: 1,
    label: "Date Filtered",
    icon: <Calendar />,
    component: <DateFilteredReport />
  },
  {
    id: 2,
    label: "Instant Download",
    icon: <TableOutlined />,
    component: <InstantReport />
  }
]

const renderTabBar = (props, DefaultTabBar) => (
  <StickyBox offsetTop={64} offsetBottom={0} style={{ zIndex: 1, background: '#fff' }}>
    <DefaultTabBar {...props} />
  </StickyBox>
);

const GroupByTab = () => {
  return (
    <section
      style={{
        maxWidth: '1024px',
        margin: '0 auto'
      }}
    >
      <Tabs
        defaultActiveKey={items[0].id}
        renderTabBar={renderTabBar}
        items={items.map(item => {
          return {
            label: item.label,
            key: item.id,
            children: item.component,
          };
        })}
      />
    </section>
  );
};

export default GroupByTab;
